import { Routes } from '@angular/router';
import { LoginComponent } from './features/auth/login/login.component';
import { RegisterComponent } from './features/auth/register/register.component';
import { HomeComponent } from './features/home/home.component';
import { ChatComponent } from './features/chat/chat.component';
import { SettingsComponent } from './features/settings/settings.component';
import { authGuard } from './services/auth.guard';
import { PreChatsComponent } from './features/pre-chats/pre-chats.component';
import { MindchangeComponent } from './mindchange/mindchange.component';


export const routes: Routes = [
    { path: '', component: LoginComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'home', component: HomeComponent, canActivate: [authGuard] },
    { path: 'chat/:userId', component: ChatComponent, canActivate: [authGuard] },
    { path: 'settings', component: SettingsComponent, canActivate: [authGuard] },
        { path:'prechat', component:PreChatsComponent, canActivate: [authGuard]},
        {path: 'user-pref',component:MindchangeComponent, canActivate: [authGuard]},

    { path: '**', redirectTo: '' },

];
